import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { AlertColor } from '@mui/material';

import { ReactNode, SyntheticEvent, useCallback, useState, memo } from 'react';
import { StateDispatch } from '../../../constants/interfaces';

interface Props {
  children: ({
    setPopupMessage
  }: {
    setPopupMessage: StateDispatch<string>;
    setIsPopupOpen: StateDispatch<boolean>;
  }) => ReactNode;
  severity: AlertColor;
  autoHideDuration?: number;
}

const Message = ({ children, severity, autoHideDuration = 5000 }: Props) => {
  const [popupMessage, setPopupMessage] = useState<string>('');
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const handlePopupClose = useCallback((event: SyntheticEvent, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsPopupOpen(false);
  }, []);

  return (
    <>
      <Snackbar open={isPopupOpen} autoHideDuration={autoHideDuration} onClose={handlePopupClose}>
        <Alert variant="filled" severity={severity}>
          {popupMessage}
        </Alert>
      </Snackbar>
      {children({ setPopupMessage, setIsPopupOpen })}
    </>
  );
};

export default memo(Message);
